export default "__VITE_ASSET__CGN$LfjJ__"